import { IGeneralState } from '../../types/app-state'
import { ROUTE_CHANGE } from '../constants/general'

const initialState: IGeneralState = {
  isServer: true,
  urls: { BASE_URL: '', INITIAL_URL: '', currentUrl: '' },
  credentials: {
    pusher: {
      apiKey: '',
      cluster: '',
      baseUrl: ''
    },
    firebase: {
      apiKey: '',
      authDomain: '',
      databaseURL: '',
      projectId: '',
      storageBucket: '',
      messagingSenderId: ''
    }
  },
  features: {
    maalshow: false,
    maalshowLikes: false,
    maalshowViews: false,
    maalshowTags: false
  }
}

const reducer = (state = initialState, action): IGeneralState => {
  switch (action.type) {
    case ROUTE_CHANGE:
      return {
        ...state,
        urls: {
          ...state.urls,
          currentUrl: action.url
        }
      }

    default:
      return state
  }
}

export { reducer }
